/* ============================================================
   Jello PDP — assets/jlc-base.js
   Shared behaviour. Load ONCE in theme.liquid <head>:
   {{ 'jlc-base.js' | asset_url | script_tag }}
   1. carousel: dots + arrows for every [data-rail] with a sibling [data-nav]
   2. overlays: close on X, backdrop click or Escape
   3. video tiles: window.jlInlineVideos(root) - Poster + Play, kein Autoplay, Klick-Kreis stumm/Ton
   4. window.jlcOnSection(selector, fn) — init helper used by every section's {% javascript %}
   Load it in <head> WITHOUT defer so it is there before the sections' bundled JS runs.
   Everything is idempotent and re-runs on shopify:section:load (theme editor).
   ============================================================ */
(function(){
  if (window.__jlcBaseLoaded) return;
  window.__jlcBaseLoaded = true;

  /* Maus-Drag fuer einen Rail: am Desktop laesst sich der Streifen mit gedrueckter Maustaste
     schieben, wie mit dem Finger. Touch bleibt beim Browser (natives Scrollen). Waehrend des
     Ziehens ist Scroll-Snap aus (sonst rastet es unter der Hand), beim Loslassen rastet die
     naechstliegende Karte weich ein. Ein Klick, der aus einem Zug entsteht, wird geschluckt —
     sonst startet beim Loslassen ueber einer Videokachel das Video. */
  function dragScroll(rail,step){
    let down=false,moved=false,axis=null,x0=0,y0=0,base=0,pid=null,t=null;
    rail.addEventListener("pointerdown",e=>{
      if(e.pointerType!=="mouse"||e.button)return;
      down=true;moved=false;axis=null;x0=e.clientX;y0=e.clientY;base=rail.scrollLeft;pid=e.pointerId;
    });
    const end=()=>{
      if(!down)return;
      down=false;axis=null;
      if(!moved)return;
      const s=step();
      if(s>0)rail.scrollTo({left:Math.round(rail.scrollLeft/s)*s,behavior:"smooth"});
      rail.dataset.jlDragged="1";
      setTimeout(()=>{delete rail.dataset.jlDragged;},0);
      t=setTimeout(()=>rail.classList.remove("jlc-dragging"),450);
    };
    rail.addEventListener("pointermove",e=>{
      if(!down)return;
      /* Taste ist nicht mehr gedrueckt (ausserhalb des Streifens losgelassen): Zug beenden.
         Sonst zog der Streifen beim Wiedereintritt der Maus weiter, ohne dass jemand drueckt. */
      if(e.pointerType==="mouse"&&!(e.buttons&1)){end();return;}
      const dx=e.clientX-x0,dy=e.clientY-y0;
      if(!axis){
        if(Math.abs(dx)<5&&Math.abs(dy)<5)return;
        axis=Math.abs(dx)>Math.abs(dy)?"x":"y";
        if(axis!=="x"){down=false;return;}
        moved=true;clearTimeout(t);rail.classList.add("jlc-dragging");
        if(rail.setPointerCapture)try{rail.setPointerCapture(pid);}catch(err){}
      }
      e.preventDefault();
      rail.scrollLeft=base-dx;
    });
    rail.addEventListener("pointerup",end);
    rail.addEventListener("pointercancel",end);
    /* Loslassen irgendwo im Fenster oder Fensterwechsel beendet den Zug ebenfalls */
    window.addEventListener("pointerup",end);
    window.addEventListener("pointercancel",end);
    window.addEventListener("blur",end);
    rail.addEventListener("click",e=>{if(rail.dataset.jlDragged){e.stopPropagation();e.preventDefault();}},true);
    rail.addEventListener("dragstart",e=>e.preventDefault());
  }

  /* Rails: Punkte + Pfeile fuer jedes [data-rail] mit Geschwister-[data-nav], Maus-Drag fuer alle.
     data-loop macht den Rail endlos: die Karten stehen doppelt im Rail, sobald der Scroll in der
     zweiten Haelfte zur Ruhe kommt, springt er unsichtbar in die erste zurueck (und umgekehrt).
     Pfeile sind dann nie disabled, die Punkte rechnen modulo Kartenzahl. */
  function initRails(root){
    (root||document).querySelectorAll("[data-rail]").forEach(rail=>{
      if(rail.dataset.jlInit)return;
      rail.dataset.jlInit="1";
      const nav=rail.parentElement.querySelector("[data-nav]");
      const loop=rail.hasAttribute("data-loop");
      const n=rail.children.length;
      const cloneOf=el=>{
        const c=el.cloneNode(true);
        c.setAttribute("aria-hidden","true");c.removeAttribute("id");
        [c,...c.querySelectorAll("*")].forEach(x=>{
          x.removeAttribute("data-shopify-editor-block");
          if(x.dataset){delete x.dataset.vReady;delete x.dataset.vState;delete x.dataset.clampReady;}
          if(x.hasAttribute("tabindex")||/^(A|BUTTON)$/.test(x.tagName))x.setAttribute("tabindex","-1");
        });
        return c;
      };
      /* echten Spaltenabstand lesen statt 12 anzunehmen: sonst passt die Schrittweite nicht
         zum Scroll-Snap und das Karussell haengt zwischen zwei Karten fest */
      const step=()=>{const g=parseFloat(getComputedStyle(rail).columnGap||"")||10;
        return rail.children[0]?rail.children[0].getBoundingClientRect().width+g:0;};
      const half=()=>step()*n;   /* Breite einer Kopie = Sprungweite des Loops */
      const jump=x=>{rail.scrollTo({left:x,behavior:"instant"});};
      /* goal/inflight: Ziel der laufenden Pfeil-Animation. Jeder Klick baut auf dem Ziel auf,
         nicht auf der Position mitten in der Bewegung — sonst summierte sich beim Dauerklicken
         nichts sauber. pending: der Zurueck-Pfeil am Anfang springt erst unsichtbar in die
         naechste Kopie und faehrt von dort weich zurueck; das scrollend dieses Sprungs darf der
         Ruhe-Reset nicht als "am Ende angekommen" lesen. */
      let pending=false,goal=null,inflight=false;
      dragScroll(rail,step);
      if(loop&&n>=2){
        const originals=[...rail.children];
        originals.forEach(el=>rail.appendChild(cloneOf(el)));
        /* Bei breiten Fenstern reichen zwei Kopien nicht: der unsichtbare Sprung passiert beim
           Ueberschreiten einer Kopienbreite, und bis dahin darf die Spur nie an ihr physisches
           Ende laufen. Also Kopien nachlegen, bis hinter der Grenze ein Fenster plus zwei Karten
           Luft ist. Vorher lief JLC 24 beim Dauerklicken ans Ende, stoppte und sprang sichtbar. */
        let copies=2,guard=0;
        while(guard<4&&step()>0&&(copies-1)*half()<rail.clientWidth+2*step()){
          originals.forEach(el=>rail.appendChild(cloneOf(el)));copies++;guard++;
        }
        if(window.jlInlineVideos)window.jlInlineVideos(rail);
        /* In Ruhe: liegt die Spur in einer Kopie hinter der ersten, unsichtbar zurueck. Nur in
           Ruhe, weil ein Reset mitten im Finger-Scroll auf iOS den Schwung abbricht. */
        const settle=()=>{const h=half();if(h<=0)return;
          if(pending){pending=false;return;}
          if(rail.scrollLeft>=h)jump(rail.scrollLeft-h);else if(rail.scrollLeft<0)jump(rail.scrollLeft+h);};
        const rest=()=>{inflight=false;settle();};
        if("onscrollend" in window)rail.addEventListener("scrollend",rest);
        else{let st;rail.addEventListener("scroll",()=>{clearTimeout(st);st=setTimeout(rest,120);},{passive:true});}
        /* Waehrend einer Pfeil-Animation: Grenze ueberschritten → sofort um eine Kopienbreite
           zurueck (gleiches Bild, unsichtbar) und die Animation auf das verschobene Ziel neu
           ansetzen. So laeuft Dauerklicken endlos durch, ohne je das Ende zu erreichen. */
        rail.addEventListener("scroll",()=>{
          if(!inflight||goal===null)return;const h=half();if(h<=0)return;
          if(rail.scrollLeft>=h&&goal>=h){jump(rail.scrollLeft-h);goal-=h;rail.scrollTo({left:goal,behavior:"smooth"});}
        },{passive:true});
        const userTakesOver=()=>{inflight=false;goal=null;};
        rail.addEventListener("pointerdown",userTakesOver);
        rail.addEventListener("touchstart",userTakesOver,{passive:true});
        rail.addEventListener("wheel",userTakesOver,{passive:true});
      }
      if(!nav)return;
      /* Ohne Loop: nur so viele Punkte wie echte Scroll-Positionen. Stehen am Desktop drei Karten
         nebeneinander, gibt es bei fuenf Karten nur drei Positionen; vorher blieb am Ende der
         dritte von fuenf Punkten aktiv und es sah aus, als ginge es weiter (Timo, 30.09.). */
      const positions=()=>{if(loop)return n;const s=step();if(s<=0)return n;
        return Math.max(1,n-Math.max(1,Math.floor((rail.clientWidth+4)/s))+1);};
      const dotsHtml=()=>Array.from({length:positions()},(_,i)=>`<i class="${i?"":"jlc-on"}"></i>`).join("");
      nav.innerHTML=`<div class="jlc-dots">${dotsHtml()}</div>
      <div class="jlc-arws"><button type="button" class="jlc-arw" data-d="-1" aria-label="Zurück">‹</button><button type="button" class="jlc-arw" data-d="1" aria-label="Weiter">›</button></div>`;
      let dots=nav.querySelectorAll(".jlc-dots i");
      const atEnd=()=>rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;
      const index=()=>{const s=step();if(s<=0)return 0;const i=Math.round(rail.scrollLeft/s);
        if(loop)return ((i%n)+n)%n;const p=positions();return atEnd()?p-1:Math.min(p-1,Math.max(0,i));};
      nav.querySelectorAll(".jlc-arw").forEach(a=>a.addEventListener("click",()=>{
        const d=+a.dataset.d,s=step();if(s<=0)return;
        /* auf dem laufenden Ziel aufbauen, aber hoechstens zwei Karten vor der echten Position —
           sonst laeuft die Spur nach dem letzten Klick noch lange nach */
        const from=(inflight&&goal!==null)?goal:rail.scrollLeft;
        let target=from+d*s;
        target=d>0?Math.min(target,rail.scrollLeft+2*s):Math.max(target,rail.scrollLeft-2*s);
        if(loop&&target<0){pending=true;jump(rail.scrollLeft+half());target+=half();}
        goal=target;inflight=true;
        rail.scrollTo({left:target,behavior:"smooth"});
      }));
      /* Punkte sind antippbar: springt direkt zur Karte (im Loop innerhalb der aktuellen Haelfte) */
      const bindDots=()=>dots.forEach((d,k)=>d.addEventListener("click",()=>{
        const s=step();if(s<=0)return;
        const cur=Math.round(rail.scrollLeft/s),base=loop?cur-(((cur%n)+n)%n):0;
        goal=null;inflight=false;
        rail.scrollTo({left:(base+k)*s,behavior:"smooth"});
      }));
      bindDots();
      if(!loop){let rt;window.addEventListener("resize",()=>{clearTimeout(rt);rt=setTimeout(()=>{
        const box=nav.querySelector(".jlc-dots");if(!box||box.children.length===positions())return;
        box.innerHTML=dotsHtml();dots=box.querySelectorAll("i");bindDots();rail.dispatchEvent(new Event("scroll"));
      },150);});}
      rail.addEventListener("scroll",()=>{
        const i=index();
        dots.forEach((d,k)=>d.classList.toggle("jlc-on",k===i));
        if(!loop){
          nav.querySelector('[data-d="-1"]').disabled=rail.scrollLeft<4;
          nav.querySelector('[data-d="1"]').disabled=atEnd();
        }
      },{passive:true});
      rail.dispatchEvent(new Event("scroll"));
    });
  }
  function closeAll(){document.querySelectorAll(".jlc-ov.jlc-show").forEach(o=>{o.classList.remove("jlc-show");const v=o.querySelector("video");if(v){v.pause();v.removeAttribute("src");v.load();}});}
  if(!window.jlBase){
    window.jlBase=true;
    document.addEventListener("click",e=>{if(e.target.closest("[data-close]")||e.target.classList.contains("jlc-ov"))closeAll();});
    document.addEventListener("keydown",e=>{if(e.key==="Escape")closeAll();});
    document.addEventListener("shopify:section:load",e=>initRails(e.target));
  }
  window.jlInitRails=initRails;
  /* jlcOnSection(selector, fn): run fn(el) once per matching element — now (DOM ready) and again for
     sections re-rendered by the theme editor (shopify:section:load). Sections use it for their own JS. */
  window.jlcOnSection=function(sel,fn){
    const run=root=>(root||document).querySelectorAll(sel).forEach(el=>{if(el.dataset.jlReady)return;el.dataset.jlReady="1";fn(el);});
    document.readyState==="loading"?document.addEventListener("DOMContentLoaded",()=>run()):run();
    document.addEventListener("shopify:section:load",e=>run(e.target));
  };
  /* Videokacheln. KEIN Autoplay - Salman hat es wegen der Ladezeit ausgeschlossen, und
     preload="none" im Markup sorgt dafuer, dass vor dem ersten Klick nichts geladen wird.
     Stattdessen ein Klick-Kreis pro Kachel:
       Poster  -> Klick -> laeuft stumm  -> Klick -> laeuft mit Ton -> Klick -> zurueck aufs Poster
     Ton gibt es immer nur auf einer Kachel; jede andere wird beim Aufdrehen stumm.
     Scrollt eine laufende Kachel aus dem Bild, wird sie pausiert und zurueckgesetzt,
     damit kein Ton aus dem Nichts kommt. */
  function vstate(t,st){
    const v=t.querySelector("video"),snd=t.querySelector("[data-vsound]"),play=t.querySelector(".jlc-vtile__play");
    if(!v)return;
    t.dataset.vState=st;
    if(play)play.hidden=st!=="idle";
    if(snd){snd.hidden=st==="idle";snd.textContent=st==="loud"?snd.dataset.on:snd.dataset.off;}
    t.classList.toggle("jlc-loud",st==="loud");
  }
  function vstop(t){
    const v=t.querySelector("video");if(!v)return;
    v.pause();v.muted=true;try{v.currentTime=0;}catch(e){}
    v.removeAttribute("controls");vstate(t,"idle");
  }
  window.jlInlineVideos=function(root){
    const tiles=[...(root||document).querySelectorAll("[data-inline-video]")].filter(t=>!t.dataset.vReady);
    if(!tiles.length)return;
    tiles.forEach(t=>{t.dataset.vReady="1";vstate(t,"idle");});
    if(!("IntersectionObserver" in window))return;
    const io=new IntersectionObserver(es=>es.forEach(e=>{
      if(!e.isIntersecting&&e.target.dataset.vState!=="idle")vstop(e.target);
    }),{threshold:.25});
    tiles.forEach(t=>io.observe(t));
  };
  function vcycle(t){
    const v=t.querySelector("video");if(!v)return;
    const st=t.dataset.vState||"idle";
    if(st==="loud"){vstop(t);return;}
    if(st==="muted"){
      document.querySelectorAll('[data-inline-video][data-v-state="loud"]').forEach(o=>{if(o!==t)vstop(o);});
      v.muted=false;v.play().catch(()=>{});vstate(t,"loud");return;
    }
    v.muted=true;v.play().catch(()=>{});vstate(t,"muted");
  }
  document.addEventListener("click",e=>{
    const t=e.target.closest("[data-inline-video]");if(t)vcycle(t);
  });
  /* Tastatur: die Kachel ist role=button mit tabindex=0 (snippet jlc-video-inline) */
  document.addEventListener("keydown",e=>{
    if(e.key!=="Enter"&&e.key!==" ")return;
    const t=e.target.closest&&e.target.closest("[data-inline-video]");
    if(t){e.preventDefault();vcycle(t);}
  });
  /* Lange Bewertungen auf drei Zeilen kuerzen und aufklappbar machen. Der Knopf erscheint
     nur, wo der Text tatsaechlich ueberlaeuft — gemessen wird im gekuerzten Zustand.
     Nach dem Aufklappen bleibt er stehen und klappt wieder zu. */
  window.jlClampReviews=function(root){
    (root||document).querySelectorAll("[data-clamp]").forEach(p=>{
      /* Schon eingerichtet: nur neu messen. Vorher wurden Karten, die beim ersten Lauf noch
         hidden waren (Review-Liste ab Karte 7), uebersprungen — Masse 0, kein Knopf, und beim
         Aufdecken kam der Knopf nie nach. Lange Texte blieben auf drei Zeilen gekappt. */
      if(p._jlcCheck){p._jlcCheck();return;}
      p.dataset.clampReady="1";
      p.classList.add("jlc-cut");
      const btn=document.createElement("button");
      btn.type="button";btn.className="jlc-rev-more";
      const more=p.dataset.more||"Weiterlesen",less=p.dataset.less||"Weniger";
      btn.textContent=more;
      p.after(btn);
      const check=()=>{
        const cut=p.classList.contains("jlc-cut");
        if(!cut)return;
        btn.classList.toggle("jlc-on",p.scrollHeight-p.clientHeight>4);
      };
      btn.addEventListener("click",()=>{
        const cut=p.classList.toggle("jlc-cut");
        btn.textContent=cut?more:less;
      });
      p._jlcCheck=check;
      check();addEventListener("resize",check);
      if(document.fonts&&document.fonts.ready)document.fonts.ready.then(check);
    });
  };
  const clampRun=()=>window.jlClampReviews();
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",clampRun):clampRun();
  document.addEventListener("shopify:section:load",e=>window.jlClampReviews(e.target));

  /* CTA ohne eigenes Ziel (href="#") springt zum naechstgelegenen Kaufblock — nach unten
     oder nach oben, je nachdem welcher naeher liegt. Bleibt damit richtig, wenn die
     Sections im Editor umsortiert werden. Ein im Editor gesetzter Link gewinnt. */
  document.addEventListener("click",e=>{
    const a=e.target.closest&&e.target.closest('a.jlc-btn[href="#"]');
    if(!a)return;
    const boxes=[...document.querySelectorAll("[data-buy-mount]")].filter(b=>b.getClientRects().length);
    if(!boxes.length)return;
    e.preventDefault();
    const from=a.getBoundingClientRect().top;
    let best=null,bestD=Infinity;
    boxes.forEach(b=>{const d=Math.abs(b.getBoundingClientRect().top-from);if(d<bestD){bestD=d;best=b;}});
    if(!best)return;
    const y=best.getBoundingClientRect().top+window.pageYOffset-90;
    window.scrollTo({top:Math.max(y,0),behavior:"smooth"});
  });
  const run=()=>initRails(document);
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",run):run();

  /* Scroll-Reveal fuer alle jlc-Sections ausser Kaufbereich, Ticker und Ankuendigung. Markiert
     wird nur, was beim Laden unter dem Bildschirm liegt: nichts blitzt auf, und ohne JS oder bei
     reduzierter Bewegung bleibt alles einfach sichtbar. Nach dem Einblenden fliegen Attribute und
     Delays wieder raus, damit Hover-Transitions und position:fixed in Overlays normal greifen. */
  const RV_STAG="[data-rail],.jlc-hw-steps,.jlc-grid4,.jlc-sc-grid,.jlc-stats,.jlc-stl,.jlc-faq-list,.jlc-rev-list,.jlc-sv-rows,.jlc-tl,.jlc-vids,.jlc-benefits6";
  const rvOk=("IntersectionObserver" in window)&&!matchMedia("(prefers-reduced-motion: reduce)").matches;
  let rvIO=null;
  function rvDone(el){
    if(el._rvDone)return;el._rvDone=true;
    el.classList.add("jlc-in");
    setTimeout(()=>{
      el.removeAttribute("data-rv");el.removeAttribute("data-rv-stag");el.classList.remove("jlc-in");
      el.style.removeProperty("--rv-d");[...el.children].forEach(c=>c.style.removeProperty("--rv-i"));
    },1800);
  }
  function rvInit(root){
    if(!rvOk)return;
    document.documentElement.classList.add("jlc-rv-on");
    if(!rvIO)rvIO=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;rvIO.unobserve(e.target);rvDone(e.target);}),{rootMargin:"0px 0px -8% 0px"});
    const fold=innerHeight*.92;
    const mark=(el,stag,delay)=>{
      if(el.dataset.rvSeen)return;el.dataset.rvSeen="1";
      if(!el.getClientRects().length||el.getBoundingClientRect().top<fold)return;
      if(stag){el.setAttribute("data-rv-stag","");[...el.children].forEach((c,i)=>c.style.setProperty("--rv-i",Math.min(i,6)));}
      else{el.setAttribute("data-rv","");if(delay)el.style.setProperty("--rv-d",delay+"ms");}
      rvIO.observe(el);
    };
    (root||document).querySelectorAll(".jl .jlc-sec").forEach(sec=>{
      const host=sec.closest(".jl");
      if(host.querySelector(".jlc-buy-wrap,.jlc-ticker,.jlc-anno"))return;
      let box=sec,d=0;
      while(d<3&&box.children.length===1&&!box.firstElementChild.matches(RV_STAG)){box=box.firstElementChild;d++;}
      let k=0;
      [...box.children].forEach(u=>{
        if(/^(STYLE|SCRIPT|TEMPLATE|LINK)$/.test(u.tagName)||u.matches(".jlc-ov"))return;
        if(u.matches(RV_STAG)){mark(u,true);return;}
        mark(u,false,Math.min(k++,4)*90);
        u.querySelectorAll(RV_STAG).forEach(g=>mark(g,true));
      });
    });
  }
  const rvRun=()=>rvInit(document);
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",rvRun):rvRun();
  document.addEventListener("shopify:section:load",e=>rvInit(e.target));
  /* Theme-Editor: ein angeklickter Block muss sofort sichtbar sein */
  document.addEventListener("shopify:block:select",e=>{const h=e.target.closest(".jl");if(h)h.querySelectorAll("[data-rv],[data-rv-stag]").forEach(rvDone);});
})();
